@if (!editingPath()) {
  <app-input-field
    [noLabel]="true"
    [noLabelExtraSpacing]="true"
    class="gallery-path-field headless"
    [class.disabled]="
      item().public_access === 'no_access' || (item().tenant || activeTenant())['block_public_link_access']
    "
  >
    <div
      fake-input
      class="fake-input-path no-hover"
      [class.disabled]="
        item().public_access === 'no_access' || (item().tenant || activeTenant())['block_public_link_access']
      "
      [class.copy-only]="!folderOrGalleryPermissions().can_edit"
    >
      <span>{{ publicLinkPre() || 'Loading...' }}</span>
      <span
        class="post"
        (click)="startEditPath()"
        data-test-id="gallery-path-update"
        [appTooltip]="
          (item().public_access === 'no_access' || !folderOrGalleryPermissions().can_edit) &&
          !(item().tenant || activeTenant())['block_public_link_access']
            ? ''
            : 'Click to rename this link'
        "
        >{{ publicLinkPost() }}</span
      >
    </div>
    <div *appInputPost class="edit-path-buttons">
      @if (showCopyButton()) {
        <button
          appButton
          type="button"
          name="copy-link"
          location="editable-gallery-url-field"
          height="1"
          spacing="3"
          shape="round"
          color="primary"
          data-test-id="copy-share-link-button"
          [share]="publicLink()"
          (onCopied)="onCopied()"
          [attr.test-share-content]="publicLink()"
          [class.disabled]="
            !publicLink() ||
            item().public_access === 'no_access' ||
            (item().tenant || activeTenant())['block_public_link_access']
          "
        >
          @if (!canShare) {
            <span>Copy</span>
          }
          @if (canShare) {
            <span>Share</span>
          }
        </button>
      } @else if (
        showEditButton() &&
        !(
          !publicLink() ||
          item().public_access === 'no_access' ||
          (item().tenant || activeTenant())['block_public_link_access']
        )
      ) {
        <button
          appButton
          name="edit"
          class="edit-button"
          location="editable-gallery-url-field"
          [iconButton]="true"
          color="simple-gray-50"
          height="0"
          (click)="startEditPath()"
        >
          <app-svg src="/assets/icons/edit.svg" size="0"></app-svg>
        </button>
      }
    </div>
  </app-input-field>
} @else {
  <form [formGroup]="pathForm" (ngSubmit)="savePath()" class="edit-path-form show-errors-without-submitting">
    <app-input-field [control]="pathForm.controls.path" [noLabel]="true" [noLabelExtraSpacing]="true" class="headless">
      <input
        type="text"
        formControlName="path"
        placeholder="Gallery path"
        appAutofocus
        data-test-id="gallery-path-field"
      />
      <div *appInputPost class="edit-path-buttons">
        <button
          appButton
          type="button"
          name="cancel-edit-path"
          location="editable-gallery-url-field"
          color="simple-primary"
          (click)="cancelEditPath()"
          height="1"
          shape="round"
        >
          Cancel
        </button>
        <button
          appButton
          type="button"
          name="save-path"
          location="editable-gallery-url-field"
          color="primary"
          height="1"
          weight="bold"
          shape="round"
          spacing="3"
          (click)="savePath()"
          data-test-id="save-gallery-path"
        >
          <span [class.hidden-text]="savingPath()">Save</span>
          @if (savingPath()) {
            <app-loading-indicator color="white" size="small" class="button-loading-indicator"> </app-loading-indicator>
          }
        </button>
      </div>
    </app-input-field>
  </form>
}
